
riot.tag2('checkbox-list-inline', '  <label class="form-check-inline" each="{items}">\n    <input class="form-check-input" data-id="{id}" type="checkbox" __checked="{isChecked}" onclick="{click}">&nbsp {name} &nbsp&nbsp\n  </label>\n', '', '', function(opts) {
'use strict';

var self = this;

self.click = function (e) {
    var id = e.target.dataset.id;
    var isChecked = e.target.checked;
    self.items.forEach(function (item) {
        if (item.id == id) item.isChecked = isChecked;
    });

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.on('update', function () {
    self.items = opts.items;
});
});


// WEBPACK FOOTER //
// ./components/checkbox-list-inline.tag